import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndustry,
  faUsers,
  faGlobe,
  faHeart,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import "./About.css";

const About = () => {
  const values = [
    {
      icon: faIndustry,
      title: "Manufacturing Excellence",
      description:
        "We maintain the highest standards in manufacturing processes and quality control.",
    },
    {
      icon: faHeart,
      title: "Customer Focus",
      description:
        "Our customers are at the heart of everything we do, ensuring satisfaction and long-term partnerships.",
    },
    {
      icon: faLightbulb,
      title: "Innovation",
      description:
        "Continuously innovating and improving our products to meet evolving industry demands.",
    },
    {
      icon: faGlobe,
      title: "Sustainability",
      description:
        "Committed to environmentally responsible manufacturing practices and sustainable solutions.",
    },
  ];

  const achievements = [
    {
      year: "1998",
      title: "Company Founded",
      description:
        "Started operations with a vision to become a leading firebricks manufacturer.",
    },
    {
      year: "2005",
      title: "ISO Certification",
      description:
        "Achieved ISO 9001:2000 certification for quality management systems.",
    },
    {
      year: "2010",
      title: "Expansion",
      description:
        "Expanded manufacturing facility with state-of-the-art equipment.",
    },
    {
      year: "2015",
      title: "Export Market",
      description:
        "Started exporting to international markets across Asia and Europe.",
    },
    {
      year: "2020",
      title: "Digital Transformation",
      description:
        "Implemented advanced digital systems for production and quality control.",
    },
    {
      year: "2023",
      title: "Industry Recognition",
      description:
        "Received 'Excellence in Manufacturing' award from industry association.",
    },
  ];

  return (
    <div className="about">
      <div className="about-hero">
        <div className="container">
          <h1>About Ramkrishna Refractories</h1>
          <p>
            Leading the way in firebricks manufacturing with innovation,
            quality, and customer satisfaction
          </p>
        </div>
      </div>

      <div className="container">
        {/* Company Story */}
        <section className="company-story">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              {/* <p>
                Founded in 1974, Ramkrishna Industries began as a small
                family-owned business with a vision to revolutionize the
                firebricks manufacturing industry. What started as a modest
                operation has grown into one of India's leading manufacturers of
                high-quality refractory materials.
              </p>
              <p>
                Over the past 25+ years, we have consistently delivered
                innovative solutions to meet the evolving needs of various
                industries. Our commitment to quality, customer satisfaction,
                and technological advancement has been the cornerstone of our
                success.
              </p>
              <p>
                Today, we serve clients across multiple sectors including steel,
                cement, glass, chemical, and petrochemical industries, both
                domestically and internationally.
              </p> */}
              <p style={{ textAlign: "justify" }}>
                We take this opportunity to introduce ourselves as one of the
                oldest and leading manufacturer of complete range of Alumino-
                Sillicate Refractories along with relevant Mortars.
              </p>
              <p style={{ textAlign: "justify" }}>
                R.K.R. is committed to customers service and striving for
                excellence in making Refractories of all grades. Established in
                1974, it is a name that has, through its years, became
                synonymous to the steel plants, mini steel plants, heavy
                chemical, Rolling Mills, Cement and Fertilizer Industries, and
                all large and medium Foundary industries in the country.
              </p>
            </div>
            <div className="story-image">
              <div className="image-placeholder">
                <FontAwesomeIcon icon={faIndustry} />
                <p>Years of Experience</p>
              </div>
            </div>
          </div>
          <p style={{ textAlign: "justify" }}>
            R.K.R. Is situated amidst industrial hub of the state, just 1 km
            from N.H. 8.4 and behind "Wankaner Junction" Rly. Station of Western
            Rly. We are catering our products through out of the country to the
            ulmost satisfaction of our esteemed customers.
          </p>
          <p style={{ textAlign: "justify" }}>
            R.K.R. Is well arranged and fully equipped with most modern
            machineries for making both dry and wet process refractories. The
            factory is fasciliated with modern mill house, sophisticated medium
            and heavy friction screw press, hydraulic press and all other
            necessary equipment to produce quality materials.
          </p>
          <p style={{ textAlign: "justify" }}>
            The materials are fired in automated tunnel kilns to ensure high
            temperature and continues productions to meet urgent requirements of
            its valued Customers.
          </p>
          <p style={{ textAlign: "justify" }}>
            R.K.R. has an installed capacity of 600 M.Tons of Fire Bricks along
            with hollow and shaped Bricks. Furthermore the capacity is being
            expanded to 900 M. Tons of Fire Bricks, hollow and shaped Bricks
            with addition of adequate equipments etc.
          </p>
          <p style={{ textAlign: "justify" }}>
            Infact M/s R.K.R. is an Integrated Refractory Plant, which produces
            all types of FIRE CLAY REFRACTORIES, HOLOW, WARES, HIGH GROG ang
            HIGH ALUMINA (70%), LADDLE BRICKS, LADDLE SLEEVES, SILLIMANITE
            BRICKS, RELEVANT MORTARS. Ingate Pouring Systems for large and
            medium foundries.
          </p>
          <p style={{ textAlign: "justify" }}>
            M/S R.K.R. is a professionally managed unit with a well versed team
            of experienced and technical persons, who closely look after the
            quality of the products and timely delivery, which is the essence of
            the company. The day to day product are passed through vigorous
            checking in all the stages of manufacturing up to the final
            inspection and despatch.
          </p>
          <p style={{ textAlign: "justify" }}>
            With the advent of the high quality refractories and continuous
            changes in the requirements and operational hazards of the Users,
            our R & D wing is dedicated to run with the call of the times to
            serve our customers needs as well as the country...
          </p>
        </section>

        {/* Company Values */}
        <section className="company-values">
          <h2>Our Core Values</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">
                  <FontAwesomeIcon icon={value.icon} />
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="mission-vision">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <h3>Our Mission</h3>
              <p>
                To provide innovative, high-quality firebricks solutions that
                enhance the efficiency and sustainability of industrial
                processes while exceeding customer expectations through superior
                service and technical expertise.
              </p>
            </div>
            <div className="vision-card">
              <h3>Our Vision</h3>
              <p>
                To be one of the best Recognized Firebrick and allied
                refractories Manufacturers with technological innovation and
                implemention along with environment responsbilities and
                customers services.
              </p>
            </div>
          </div>
        </section>

        {/* Achievements Timeline */}
        {/* <section className="achievements">
          <h2>Our Journey</h2>
          <div className="timeline">
            {achievements.map((achievement, index) => (
              <div
                key={index}
                className={`timeline-item ${
                  index % 2 === 0 ? "left" : "right"
                }`}
              >
                <div className="timeline-content">
                  <div className="timeline-year">{achievement.year}</div>
                  <h4>{achievement.title}</h4>
                  <p>{achievement.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section> */}

        {/* Statistics */}
        {/* <section className="statistics">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">25+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Happy Clients</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Countries Served</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
          </div>
        </section> */}

        {/* Team Section */}
        {/* <section className="team-section">
          <h2>Our Leadership Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <h4>Mr. Ramkrishna Sharma</h4>
              <p>Founder & CEO</p>
              <p className="member-description">
                With over 30 years of experience in the refractory industry, Mr.
                Sharma leads our company with vision and expertise.
              </p>
            </div>
            <div className="team-member">
              <div className="member-image">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <h4>Mrs. Priya Sharma</h4>
              <p>Director - Operations</p>
              <p className="member-description">
                Oversees all manufacturing operations ensuring quality and
                efficiency in every process.
              </p>
            </div>
            <div className="team-member">
              <div className="member-image">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <h4>Mr. Rajesh Kumar</h4>
              <p>Technical Director</p>
              <p className="member-description">
                Leads our R&D team in developing innovative firebricks solutions
                for complex applications.
              </p>
            </div>
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default About;
